__turbopack_context__.v({
  "className": "newsreader_f2b279bf-module__gR8KLW__className",
  "variable": "newsreader_f2b279bf-module__gR8KLW__variable",
});
